import React from "react";
import { FaX } from "react-icons/fa6";

const HistorialCitas = ({ citasPasadas, formatearFecha, onClose }) => {
  return (
    <div className="historico-seguimiento">
      <div className="modal-content">
        <div className="modal-header mayusculas">
          <h2>HISTÓRICO DE SEGUIMIENTO</h2>
          <button className="close-button" onClick={onClose}><FaX /></button>
        </div>
        <div className="modal-body">
          <table className="w-100">
            <thead>
              <tr>
                <th className="bold">Fecha</th>
                <th className="bold">Entidad</th>
              </tr>
            </thead>
            <tbody>
              {citasPasadas.length > 0 ? (
                citasPasadas.map((cita, index) => (
                  <tr key={index}>
                    <td>{formatearFecha(cita.appointmentDate)}</td>
                    <td>{cita.service}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No hay citas anteriores.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HistorialCitas;
